import { NpcWatchPage } from '@/components/admin/npc/watch/watch-page';
import { createFileRoute } from '@tanstack/react-router';

/**
 * « Regarder » un rejeu (npc.md §11, H17, issue #210) : `/admin/npc/regarder/<id>`, où `<id>` est
 * l'identifiant du REJEU - celui de sa session.
 *
 * Un montage : la page est `NpcWatchPage`. Elle prend toute la fenêtre, par-dessus le rail, pour la
 * raison que `/s/<jeton>` prend la sienne : ce qu'on regarde est l'écran de la personne, peint par le
 * thème de l'expérience, et rien de PMS ne doit s'y mêler sauf la fine barre sombre du haut.
 */

export const Route = createFileRoute('/admin/npc/regarder/$id')({
  component: NpcWatchRoute,
});

function NpcWatchRoute() {
  const { id } = Route.useParams();
  return <NpcWatchPage replayId={id} />;
}
